var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404Preview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 279,
    viewBox: "0 0 352 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.907 70.0191C103.907 71.3013 103.907 72.3784 103.907 73.5068C103.907 111.718 103.907 149.929 103.907 188.141C103.907 196.091 107.907 202.04 114.626 204.195C124.731 207.375 134.63 200.143 134.681 189.269C134.783 171.318 134.732 153.366 134.732 135.414C134.732 134.337 134.732 133.26 134.732 132.029C162.121 132.029 189.151 132.029 216.54 132.029C216.54 133.26 216.54 134.337 216.54 135.414C216.54 153.263 216.54 171.164 216.54 189.013C216.54 196.399 220.695 202.194 227.26 204.195C237.005 207.221 246.648 200.399 247.315 189.936C247.366 188.91 247.366 187.884 247.366 186.859C247.366 148.904 247.417 110.949 247.315 72.9939C247.315 70.4294 248.135 69.7626 250.443 69.2497C262.804 66.6339 275.063 63.4539 286.347 57.5555C290.706 55.2987 294.963 52.5803 298.605 49.2978C306.35 42.3736 306.247 34.321 298.759 27.089C292.399 20.9855 284.5 17.4977 276.396 14.4203C261.932 9.03481 246.853 6.00867 231.671 3.75189C231.261 3.70061 230.799 3.75189 230.132 3.75189C230.132 14.1125 230.132 24.4219 230.132 34.6287C225.978 35.8597 225.465 35.5006 225.465 31.7564C225.465 22.9345 225.414 14.1638 225.516 5.34189C225.516 3.54674 225.106 2.87997 223.157 2.6748C198.999 -0.146164 174.739 -0.659073 150.478 0.777054C140.169 1.39255 129.911 2.77737 119.653 3.80319C118.012 3.95706 117.499 4.67513 117.55 6.26514C117.652 10.7274 117.601 15.1384 117.601 19.6006C117.601 73.5581 117.601 127.464 117.601 181.422C117.601 182.345 117.858 183.473 117.499 184.191C117.037 185.063 116.011 185.679 115.242 186.397C114.524 185.576 113.703 184.858 113.19 183.935C112.882 183.32 113.139 182.448 113.139 181.678C113.139 123.874 113.139 66.121 113.139 8.31674C113.139 7.23965 113.139 6.11125 113.139 4.82899C96.1618 7.85512 79.5437 11.3429 64.2592 19.2929C59.8482 21.601 55.5911 24.5245 52.0008 27.961C45.2818 34.3723 45.4356 41.8094 51.8469 48.5284C57.335 54.2729 64.2079 58.0684 71.5937 60.5816C81.3389 63.9155 91.3405 66.48 101.24 69.4036C101.906 69.5574 102.727 69.7113 103.907 70.0191ZM216.233 74.4813C216.335 75.1481 216.489 75.5071 216.489 75.8149C216.489 86.1242 216.489 96.4849 216.54 106.794C216.54 108.692 215.515 108.795 214.13 108.795C188.484 108.795 162.891 108.743 137.245 108.846C135.143 108.846 134.63 108.128 134.681 106.179C134.783 96.4336 134.732 86.6884 134.732 76.9946C134.732 76.2252 134.835 75.5071 134.886 74.4813C162.07 77.0971 189.049 77.0971 216.233 74.4813ZM180.124 120.643C195.255 120.643 210.334 120.643 225.465 120.643C226.234 120.643 227.157 120.386 227.722 120.745C228.594 121.207 229.773 122.079 229.773 122.848C229.773 123.618 228.645 124.489 227.824 125.054C227.363 125.361 226.491 125.208 225.824 125.208C195.409 125.208 165.045 125.208 134.63 125.208C133.963 125.208 133.091 125.413 132.629 125.054C131.809 124.489 130.68 123.566 130.68 122.848C130.68 122.13 131.86 121.258 132.732 120.745C133.347 120.438 134.219 120.643 134.989 120.643C150.068 120.643 165.096 120.643 180.124 120.643ZM180.227 47.1948C195.357 47.1948 210.488 47.1948 225.619 47.1948C227.414 47.1948 229.927 46.6306 229.825 49.5029C229.722 52.1187 227.363 51.5545 225.619 51.5545C195.357 51.5545 165.096 51.5545 134.835 51.5545C133.963 51.5545 132.988 51.7597 132.322 51.4007C131.552 50.9903 130.732 50.0158 130.68 49.2465C130.629 48.631 131.603 47.7077 132.322 47.3487C133.04 46.9897 134.014 47.1948 134.835 47.1948C149.965 47.1948 165.096 47.1948 180.227 47.1948ZM229.825 131.824C229.876 132.593 229.978 133.004 229.978 133.414C229.978 149.981 229.978 166.548 229.978 183.166C229.978 183.679 230.081 184.345 229.825 184.653C229.209 185.32 228.388 186.192 227.568 186.294C226.952 186.346 226.08 185.422 225.567 184.756C225.26 184.243 225.362 183.422 225.362 182.755C225.362 166.599 225.362 150.442 225.362 134.286C225.362 133.568 225.465 132.798 225.516 132.029C226.234 131.978 226.696 131.875 227.209 131.875C228.081 131.824 228.799 131.824 229.825 131.824ZM229.876 108.487C225.414 109.102 225.414 109.102 225.414 104.999C225.414 90.5352 225.414 76.1226 225.414 61.6587C225.414 57.9145 225.978 57.5042 229.876 58.6839C229.876 75.2507 229.876 91.8175 229.876 108.487Z",
    fill: "#E4E5E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.232 74.4812C189.048 77.097 162.018 77.097 134.886 74.4812C134.835 75.507 134.732 76.225 134.732 76.9944C134.732 86.7396 134.783 96.4847 134.681 106.179C134.681 108.128 135.142 108.846 137.245 108.846C162.89 108.794 188.484 108.794 214.129 108.794C215.566 108.794 216.591 108.692 216.54 106.794C216.489 96.4847 216.489 86.1241 216.489 75.8147C216.489 75.4557 216.386 75.1479 216.232 74.4812Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180.124 120.642C165.096 120.642 150.068 120.642 135.04 120.642C134.27 120.642 133.347 120.386 132.783 120.745C131.911 121.207 130.731 122.079 130.731 122.848C130.731 123.566 131.86 124.489 132.68 125.053C133.142 125.361 134.014 125.207 134.681 125.207C165.096 125.207 195.46 125.207 225.875 125.207C226.542 125.207 227.414 125.412 227.875 125.053C228.696 124.489 229.824 123.566 229.824 122.848C229.824 122.13 228.645 121.258 227.773 120.745C227.157 120.437 226.285 120.642 225.516 120.642C210.334 120.642 195.203 120.642 180.124 120.642Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.226 47.1952C165.096 47.1952 149.965 47.1952 134.834 47.1952C133.962 47.1952 132.988 46.9901 132.321 47.3491C131.603 47.7081 130.628 48.6314 130.68 49.2469C130.731 50.0162 131.603 50.9907 132.321 51.4011C132.988 51.7601 133.962 51.5549 134.834 51.5549C165.096 51.5549 195.357 51.5549 225.618 51.5549C227.311 51.5549 229.721 52.1191 229.824 49.5033C229.927 46.6823 227.413 47.1952 225.618 47.1952C210.488 47.1952 195.357 47.1952 180.226 47.1952Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M229.825 131.823C228.799 131.823 228.029 131.823 227.26 131.823C226.747 131.823 226.234 131.926 225.568 131.977C225.516 132.746 225.414 133.516 225.414 134.234C225.414 150.39 225.414 166.547 225.414 182.703C225.414 183.37 225.26 184.19 225.619 184.703C226.08 185.37 226.952 186.293 227.619 186.242C228.44 186.191 229.209 185.319 229.876 184.601C230.132 184.293 230.03 183.626 230.03 183.113C230.03 166.547 230.03 149.98 230.03 133.362C229.978 133.003 229.927 132.592 229.825 131.823Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M229.876 108.488C229.876 91.8189 229.876 75.2522 229.876 58.7367C225.978 57.557 225.414 57.916 225.414 61.7115C225.414 76.1754 225.414 90.588 225.414 105.052C225.414 109.155 225.414 109.155 229.876 108.488Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 136.797,
    y: 217.949,
    width: 11,
    height: 8,
    rx: 2,
    transform: "rotate(28.3344 136.797 217.949)",
    fill: "#050C26"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 224.797,
    y: 180.949,
    width: 11,
    height: 8,
    rx: 2,
    transform: "rotate(28.3344 224.797 180.949)",
    fill: "#050C26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5165 129.699L27.5218 229.229C27.4121 229.461 27.429 229.734 27.5665 229.951C27.704 230.168 27.9431 230.299 28.2 230.299H74.2C74.6142 230.299 74.95 229.963 74.95 229.549V189.799H91.45V229.549C91.45 229.963 91.7858 230.299 92.2 230.299H106.45V245.699H92.2C91.7858 245.699 91.45 246.035 91.45 246.449V272.199H74.95V246.449C74.95 246.035 74.6142 245.699 74.2 245.699H8.75V229.717L55.9753 129.699H74.5165ZM318.852 129.699L271.858 229.229C271.748 229.461 271.765 229.734 271.902 229.951C272.04 230.168 272.279 230.299 272.536 230.299H318.536C318.95 230.299 319.286 229.963 319.286 229.549V189.799H335.786V229.549C335.786 229.963 336.122 230.299 336.536 230.299H350.786V245.699H336.536C336.122 245.699 335.786 246.035 335.786 246.449V272.199H319.286V246.449C319.286 246.035 318.95 245.699 318.536 245.699H253.086V229.717L300.311 129.699H318.852Z",
    fill: "#00629C",
    stroke: "#050C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156 159.949L136 191.949V222.949",
    stroke: "#050C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M220 150.949L242 157.449L225 185.949",
    stroke: "#050C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5165 135.699L19.5218 235.229C19.4121 235.461 19.429 235.734 19.5665 235.951C19.704 236.168 19.9431 236.299 20.2 236.299H66.2C66.6142 236.299 66.95 235.963 66.95 235.549V195.799H83.45V235.549C83.45 235.963 83.7858 236.299 84.2 236.299H98.45V251.699H84.2C83.7858 251.699 83.45 252.035 83.45 252.449V278.199H66.95V252.449C66.95 252.035 66.6142 251.699 66.2 251.699H0.75V235.717L47.9753 135.699H66.5165ZM310.852 135.699L263.858 235.229C263.748 235.461 263.765 235.734 263.902 235.951C264.04 236.168 264.279 236.299 264.536 236.299H310.536C310.95 236.299 311.286 235.963 311.286 235.549V195.799H327.786V235.549C327.786 235.963 328.122 236.299 328.536 236.299H342.786V251.699H328.536C328.122 251.699 327.786 252.035 327.786 252.449V278.199H311.286V252.449C311.286 252.035 310.95 251.699 310.536 251.699H245.086V235.717L292.311 135.699H310.852Z",
    fill: "white",
    stroke: "#050C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M223 127.949C230.5 119.949 241 99.7492 223 82.9492",
    stroke: "#050C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142 110.449C137.334 104.616 127.9 90.7492 127.5 81.9492C127.1 73.1492 135.334 56.6159 139.5 49.4492",
    stroke: "#050C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M182.947 174.381L182.951 174.382C187.311 175.918 191.841 176.228 196.525 175.321C201.262 174.403 205.351 172.425 208.771 169.379C212.178 166.346 214.656 162.678 216.198 158.384L216.199 158.38C217.735 154.02 218.045 149.49 217.138 144.806L208.482 100.117C207.565 95.3798 205.586 91.2915 202.541 87.8713C199.507 84.4642 195.839 81.9863 191.546 80.4442C187.236 78.8962 182.705 78.5868 177.968 79.5042C173.283 80.4115 169.197 82.3907 165.726 85.4426L165.722 85.4458C162.315 88.4792 159.837 92.1474 158.295 96.4407C156.747 100.751 156.438 105.282 157.355 110.019L166.01 154.708C166.918 159.393 168.897 163.479 171.949 166.95L171.952 166.954C174.985 170.361 178.654 172.839 182.947 174.381ZM217.946 178.866C212.748 183.347 206.419 186.319 198.936 187.768C191.453 189.217 184.472 188.824 177.977 186.607C171.472 184.388 165.981 180.679 161.493 175.473C157.012 170.275 154.041 163.945 152.592 156.463L144.268 113.483C142.818 106 143.212 99.0193 145.428 92.5241C147.648 86.0188 151.357 80.528 156.563 76.0401C161.761 71.5592 168.09 68.5879 175.573 67.1387C183.056 65.6894 190.036 66.0829 196.531 68.299C203.037 70.5186 208.528 74.2276 213.015 79.4338C217.496 84.632 220.468 90.961 221.917 98.4438L230.241 141.424C231.69 148.906 231.297 155.887 229.081 162.382C226.861 168.888 223.152 174.378 217.946 178.866Z",
    fill: "#00629C",
    stroke: "#050C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M177.382 180.527L177.386 180.529C181.746 182.064 186.275 182.375 190.96 181.467C195.697 180.55 199.785 178.571 203.205 175.526C206.612 172.492 209.09 168.824 210.632 164.531L210.634 164.526C212.169 160.166 212.48 155.637 211.572 150.953L202.917 106.263C202 101.526 200.021 97.438 196.976 94.0178C193.942 90.6107 190.274 88.1328 185.981 86.5907C181.671 85.0427 177.139 84.7333 172.402 85.6507C167.718 86.558 163.632 88.5372 160.16 91.5891L160.157 91.5922C156.75 94.6257 154.272 98.2939 152.73 102.587C151.182 106.897 150.872 111.429 151.79 116.166L160.445 160.855C161.352 165.539 163.332 169.625 166.383 173.097L166.387 173.1C169.42 176.507 173.088 178.985 177.382 180.527ZM212.381 185.013C207.182 189.494 200.853 192.465 193.371 193.914C185.888 195.364 178.907 194.97 172.412 192.754C165.907 190.534 160.416 186.825 155.928 181.619C151.447 176.421 148.476 170.092 147.026 162.609L138.702 119.629C137.253 112.146 137.646 105.166 139.863 98.6706C142.082 92.1653 145.791 86.6745 150.997 82.1866C156.195 77.7057 162.524 74.7344 170.007 73.2851C177.49 71.8359 184.471 72.2293 190.966 74.4455C197.471 76.6651 202.962 80.3741 207.45 85.5803C211.931 90.7784 214.902 97.1075 216.351 104.59L224.676 147.57C226.125 155.053 225.732 162.034 223.515 168.529C221.296 175.034 217.587 180.525 212.381 185.013Z",
    fill: "white",
    stroke: "#050C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 48.2774,
    y1: 135.562,
    x2: 55.6133,
    y2: 130.672,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 292.277,
    y1: 135.562,
    x2: 299.613,
    y2: 130.672,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 311.277,
    y1: 195.562,
    x2: 318.613,
    y2: 190.672,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 66.2774,
    y1: 135.562,
    x2: 73.6133,
    y2: 130.672,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 310.277,
    y1: 135.562,
    x2: 317.613,
    y2: 130.672,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 327.277,
    y1: 195.562,
    x2: 334.613,
    y2: 190.672,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 328.208,
    y1: 235.909,
    x2: 335.96,
    y2: 230.741,
    stroke: "#050C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 342.184,
    y1: 236.905,
    x2: 350.955,
    y2: 230.765,
    stroke: "#050C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 342.184,
    y1: 251.905,
    x2: 350.955,
    y2: 245.765,
    stroke: "#050C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 328.208,
    y1: 277.909,
    x2: 335.96,
    y2: 272.741,
    stroke: "#050C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 19.2774,
    y1: 235.562,
    x2: 26.6132,
    y2: 230.672,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 83.2774,
    y1: 235.562,
    x2: 90.6133,
    y2: 230.672,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 83.2774,
    y1: 277.562,
    x2: 90.6133,
    y2: 272.672,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 83.2774,
    y1: 195.562,
    x2: 90.6133,
    y2: 190.672,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 67.2774,
    y1: 195.562,
    x2: 74.6133,
    y2: 190.672,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 97.2458,
    y1: 236.557,
    x2: 105.607,
    y2: 230.703,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 98.1754,
    y1: 251.546,
    x2: 105.597,
    y2: 245.774,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 136.797,
    y: 41.9492,
    width: 11,
    height: 8,
    rx: 2,
    transform: "rotate(28.3344 136.797 41.9492)",
    fill: "#050C26"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 81.8535,
    width: 11,
    height: 8,
    rx: 2,
    transform: "rotate(-38.8816 215 81.8535)",
    fill: "#050C26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Preview);
export default __webpack_public_path__ + "static/media/404-preview.d3da1adaf7fe20f14978e82faf353f8a.svg";
export { ForwardRef as ReactComponent };